import "../styles/globals.scss";
import "../styles/globalsLanding.scss";
import "../styles/global.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Head from "next/head";
import Script from "next/script";
import { useEffect, useState } from "react";
import "@fortawesome/fontawesome-svg-core/styles.css";
import TagManager from "react-gtm-module";
// Prevent fontawesome from adding its CSS since we did it manually above:
import { config } from "@fortawesome/fontawesome-svg-core";
import * as fbq from "../facebook-pixel/facebook-pixel";
import { useRouter } from "next/router";
import { tagManagerArgs } from "../utils/constants";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "../redux/store";
import BaseLayout from "../components/common/BaseLayout";

config.autoAddCss = false;

function MyApp({ Component, pageProps }) {
  const [hydrated, setHydrated] = useState(false);
  const router = useRouter();
  const [webviewEvent, setWebviewEvent] = useState(null);
  const [showChat, setShowChat] = useState(true);
  const openChatCondition =
    typeof window !== "undefined" &&
    router.query &&
    router.query.open_chat == "true";

  const handleRenderAppLayout = (Component, pageProps) => {
    return (
      <>
        <BaseLayout webviewEvent={webviewEvent}>
          <div className="components">
            <Component className="App" {...pageProps} />
          </div>
        </BaseLayout>
      </>
    );
  };

  useEffect(() => {
    window.easypaySeekhoClick = (packageName, mobile, userAgent) => {
      setWebviewEvent({ packageName, mobile, userAgent });
    };
    TagManager.initialize(tagManagerArgs);
    fbq.pageview();
  }, []);

  useEffect(() => {
    const isWebView = /(webview)/i.test(navigator.userAgent);
    if (isWebView == true) {
      setShowChat(false);
    }
  }, [showChat]);

  // open chat only open_chat in the query
  useEffect(() => {
    if (openChatCondition) {
      // Window object is available, DOM is fully loaded
      var timeInMillis = 1000;
      setTimeout(function () {
        window.fcWidgetMessengerConfig = {
          open: true,
        };
        window.fcWidget?.open();
      }, timeInMillis);
    }
  }, [router]);

  // Conditionally rendering the chat bot script only on
  const renderChatBotScript = () => {
    if ((openChatCondition || router.pathname === "/contact-us") && showChat) {
      return (
        <script
          src="//in.fw-cdn.com/31658476/839382.js"
          key="open_chat_script"
        ></script>
      );
    }
    return null;
  };

  const handleRouteChange = () => {
    fbq.pageview();
  };

  useEffect(() => {
    // the below will only fire on route changes (not initial load - that is handled in the script below)
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  useEffect(() => {
    setHydrated(true); // Only true on the client after hydration
  }, []);

  return (
    <main>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {renderChatBotScript()}
      </Head>
      <Script
        id="fb-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', ${fbq.FB_PIXEL_ID});
            fbq('track', 'PageView');
          `,
        }}
        crossOrigin="anonymous"
      />
      <Provider store={store}>
        {/* Delay PersistGate until client is ready, delayed persist gate because it was effecting SEO meta tags */}
        {hydrated ? (
          <PersistGate loading={null} persistor={persistor}>
            {handleRenderAppLayout(Component, pageProps)}
          </PersistGate>
        ) : (
          handleRenderAppLayout(Component, pageProps)
        )}
      </Provider>
    </main>
  );
}

export default MyApp;
